export default "https://fiverr-res.cloudinary.com/npm-assets/layout-service/become_a_seller.9095ba3.png";